<template>
  <div :id="`${source}_audience_type_selector`" class="flex flex-col gap-6">
    <div id="dialer_type" class="form_col">
      <span>Dialer Type</span>
      <CustomSelector
        v-model="formData.dialerType"
        :source="`${source}_audience_type_selector`"
        :options="callCampaignDialerTypeOptions"
        :direction="customSelectorDirections.HORIZONTAL"
        :horizontal-align="customSelectorHorizontalAlignOptions.START"
      />
    </div>

    <div
      id="number_of_parallel_calls"
      v-if="formData.dialerType === dialerTypes.PARALLEL_DIALER"
      class="form_col"
    >
      <span>Number of parallel calls</span>
      <a-select
        v-model:value="formData.parallelCalls"
        placeholder="Select number of parallel calls"
      >
        <a-select-option v-for="index in 4" :key="index + 1" :value="index + 1">
          {{ index + 1 }}
        </a-select-option>
      </a-select>
    </div>
  </div>
</template>

<script setup>
import {
  dialerTypes,
  callCampaignDialerTypeOptions,
} from "@/src/constants/callConstants.js";
import CustomSelector from "@/src/components/CustomSelector.vue";
import {
  customSelectorDirections,
  customSelectorHorizontalAlignOptions,
} from "@/src/constants/customComponentConstants.js";

const props = defineProps({
  source: { type: String, required: true },
  formData: {
    type: Object,
    required: true,
    default: () => ({
      dialerType: dialerTypes.POWER_DIALER,
      parallelCalls: null,
    }),
  },
});
</script>
